import React from 'react';
import PropTypes from 'prop-types';
import { capitalFirstLetter } from '../../../helpers/index';

import './chatuseravatar.scss';

const ChatUserAvatar = ({ ...props }) => {
  const { onlineStatus, coverUrl, trans } = props;
  let avatarPhoto = `${process.env.REACT_APP_PORTAL_URL}/static/img/smiley-red.svg`;
  if (coverUrl !== '') {
    avatarPhoto = coverUrl;
  }
  const chatRoomUserPhotoStyle = {
    backgroundImage: `url(${avatarPhoto})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };
  return (
    <div className="chat-user">
      <div className="chat-user-photo" style={chatRoomUserPhotoStyle} />
      <div className="online-status-wrapper">
        <span
          className={`online-indicator ${onlineStatus}`}
          style={{ position: 'absolute', bottom: 1, right: 0 }}
        />
      </div>
    </div>
  );
};

ChatUserAvatar.propTypes = {
  coverUrl: PropTypes.string.isRequired,
  onlineStatus: PropTypes.string.isRequired,
  trans: PropTypes.shape().isRequired,
};

export default ChatUserAvatar;
